module.exports = "/images/cart.svg?048cb2a48a1ad9ae6e4c12c7eafe0091";